<template>
  <v-text-field
    outlined
    dense
    :hide-details="!required"
    class="money-input"
    placeholder="0"
    maxlength="10"
    v-model="inputValue"
    :label="label"
    :data-tourid="tourId"
    :disabled="disabled"
    :prefix="currencySymbol"
    :rules="rules"
    :suffix="period ? `${currencyCode}/${period}` : currencyCode"
    @blur="$emit('onBlur')"
    @keydown="keyPress"
    @input="onInput"
  >
  </v-text-field>
</template>

<script>
const KEY_CODES = {
  BACKSPACE: 8,
  ZERO: 48,
  NINE: 57,
  NUM_PAD_ZERO: 96,
  NUM_PAD_NINE: 105,
  TAB: 9,
  DOT: 190,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
}

export default {
  name: 'MoneyInput',

  props: {
    label: {
      type: String,
      required: false,
    },
    currencySymbol: {
      type: String,
      required: false,
      default: '$',
    },
    currencyCode: {
      type: String,
      required: true,
    },
    period: {
      type: String,
      required: false,
    },
    value: {
      type: [String, Number],
      required: false,
    },
    tourId: {
      type: String,
      required: false,
      default: 'money-input',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    allowDecimals: {
      type: Boolean,
      default: false,
    },
    required: Boolean,
  },

  data() {
    return {
      inputValue: null,
    }
  },

  watch: {
    value(newVal) {
      this.inputValue = newVal
    },
  },

  mounted() {
    this.inputValue = this.value
  },

  computed: {
    rules() {
      return this.required
        ? [
            field =>
              Boolean(field) ||
              this.$t('validation.form.this_field_is_required'),
          ]
        : []
    },
  },

  methods: {
    keyPress(event) {
      // Solution to avoid decimals in input an not number characters
      // IMPORTANT: the use of v-model in the input allow us to manipulate the value
      // in order to remove the non digit characters, while using only :value is not gonna be updated
      // just because the input element works like that
      const keyCode = event.keyCode ?? event.which

      if (keyCode === KEY_CODES.BACKSPACE) return

      if (keyCode == KEY_CODES.TAB) return

      const isNumber =
        (keyCode >= KEY_CODES.ZERO && keyCode <= KEY_CODES.NINE) ||
        (keyCode >= KEY_CODES.NUM_PAD_ZERO &&
          keyCode <= KEY_CODES.NUM_PAD_NINE) ||
        (this.allowDecimals &&
          keyCode === KEY_CODES.DOT &&
          !String(this.inputValue)?.match(/\./g)) ||
        (keyCode >= KEY_CODES.LEFT && keyCode <= KEY_CODES.DOWN)
      if (!isNumber) event.preventDefault()
    },

    onInput(value) {
      const parsedValue = this.allowDecimals ? value : parseInt(value, 10)
      this.$emit('onInput', isNaN(parsedValue) ? null : parsedValue)
    },
  },
}
</script>
<style lang="scss">
.money-input .v-text-field__suffix {
  height: 25px;
  right: 0;
  padding-left: $space-2;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $color-white;
  z-index: 1;
}
</style>
